import { storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc';
import { resolveLink } from '@/lib/helpers';

const FooterColumn = ({ blok }) => {
  const links = blok.links || [];

  return (
    <div className="min-w-[150px]" {...storyblokEditable(blok)}>
      {blok.title && (
        <strong className="block text-18 font-extrabold mb-6">{blok.title}</strong>
      )}
      <ul className="flex flex-col gap-2">
        {links.map((link) => (
          <li key={link._uid}>
            <a
              href={resolveLink(link.url)}
              className="text-14 text-white hover:text-white/50 transition-colors"
              {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            >
              {link.label}
              {/* A Nav Link can also hold blocks (Text, Grid, Icon…). <a> takes flow
                  content, so these render inside the link itself. */}
              {(link.body || []).map((nestedBlok) => (
                <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
              ))}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterColumn;
